export const BarcodeLiftPage = () => {
    return <>BarcodeLiftPage</>
}